import { MainThunkDispatch, State } from "../../Reducers"
import { createClient, ContentfulClientApi, Entry } from "contentful"
import { safePromise } from "../../Helpers/Functions/promise"
import { ContentfulType } from "../Types"
import { DataProgramModel, ContentType } from "../../Models/External/Contentful"
import { TemplateSlug } from "../../Models/API/AppTemplateModel"
import { Map } from "immutable"

export const getDataProgramList =
    () => async (dispatch: MainThunkDispatch, getState: () => State) => {
        const client = getClient(getState())
        const { error, data } = await safePromise(
            client.getEntries({
                content_type: ContentType.dataProgram,
                limit: 1000
            })
        )

        if (error !== undefined || data === undefined) return

        dispatch({
            type: ContentfulType.receiveDataProgramList,
            payload: data.items.map(s => s as any as Entry<DataProgramModel>)
        })
    }

export const getDataProgram =
    (slug: TemplateSlug) =>
    async (dispatch: MainThunkDispatch, getState: () => State) => {
        dispatch({
            type: ContentfulType.requestDataProgram,
            payload: slug
        })

        const client = getClient(getState())
        const { error, data } = await safePromise(
            client.getEntries({
                content_type: ContentType.dataProgram,
                "fields.slug": slug
            })
        )

        if (data === undefined) return

        if (error !== undefined || data.items.length === 0) {
            const message = error === undefined ? "Not found" : error.message

            dispatch({
                type: ContentfulType.receiveDataProgramErrors,
                payload: Map<TemplateSlug, string>().set(slug, message)
            })

            return
        }

        dispatch({
            type: ContentfulType.receiveDataProgram,
            payload: data.items[0] as Entry<DataProgramModel>
        })
    }

function getClient(state: State): ContentfulClientApi {
    const settings = state.client.endpoints.contentful

    return createClient({
        space: settings.spaceID,
        accessToken: settings.accessToken,
        environment: settings.environment
    })
}
